"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSubscriptionLogic = useSubscriptionLogic;
var _useErrorEvent = require("./useErrorEvent");
var _useOpenEvent = require("./useOpenEvent");
var _useSaveEvent = require("./useSaveEvent");
function useSubscriptionLogic({
  placementFromUrl,
  uriTemplateFromUrl
}) {
  const {
    placementFromEvent,
    uriTemplateFromEvent,
    ...openLogic
  } = (0, _useOpenEvent.useOpenEvent)();
  const saveLogic = (0, _useSaveEvent.useSaveEvent)();
  const errorLogic = (0, _useErrorEvent.useErrorEvent)();
  const placement = placementFromEvent ?? placementFromUrl;
  const uriTemplate = uriTemplateFromEvent ?? uriTemplateFromUrl;
  return {
    ...openLogic,
    ...saveLogic,
    ...errorLogic,
    placement,
    uriTemplate
  };
}
